export default (notificationId) => `notification:${notificationId}`
